module.exports = __webpack_public_path__ + "static/media/icon-fail.4a3f393e.png";